<div [formGroup]="candidateForm">
	@if (!hideCandidateFields) {
		<div class="grid grid-cols-2 gap-4">
			<!-- Staff Number -->
			<div class="form-element">
				<mat-label for="form-name">Staff Number</mat-label>
				<mat-form-field appearance="outline" class="form-field-responsive mt-1 w-full">
					<input
						type="text"
						formControlName="staffNumber"
						matInput
						maxlength="7"
						[readonly]="!isOnline"
						(focusout)="onFocusOut($event)"
					/>
					@if (staffNumber.errors && !staffNumber.hasError("ownStaffNumber")) {
						<mat-error>{{ sharedService.getErrorMessage(staffNumber) }}</mat-error>
					}
				</mat-form-field>
				@if (staffNumber.hasError("ownStaffNumber")) {
					<p class="mt-1 text-sm text-red">{{ sharedService.errorMessages.ownStaffNumber }}</p>
				}
			</div>

			<!-- Candidate Name -->
			<div class="form-element">
				<mat-label for="form-name">Name</mat-label>
				<mat-form-field appearance="outline" class="form-field-responsive mt-1 w-full">
					<input type="text" formControlName="name" matInput [readonly]="isOnline || lockCandidateIdentityFields" />
					@if (name.errors) {
						<mat-error>{{ sharedService.getErrorMessage(name) }}</mat-error>
					}
				</mat-form-field>
			</div>

			<!-- Candidate Rank -->
			<app-cbta-autocomplete
				[label]="'Rank'"
				[placeholder]="'Please Select'"
				[data]="rank.value"
				(focusOut)="saveRank($event)"
				[options]="filteredRankOptions"
				[field]="rank"
				[readonly]="lockCandidateIdentityFields"
				[clearable]="useTs1V3FlightDetails"
				[selectOnly]="dropdownSelectOnly"
			></app-cbta-autocomplete>

			@if (isTS1) {
				<!-- Pilot Profile -->
				<app-cbta-autocomplete
					[label]="'Trainee Profile'"
					[placeholder]="'Please Select'"
					[data]="pilotProfile.value"
					(focusOut)="savePilotProfile($event)"
					[options]="sharedService.dropDownOptionsPilotProfile"
					[field]="pilotProfile"
					[readonly]="lockCandidateIdentityFields"
					[clearable]="useTs1V3FlightDetails"
					[selectOnly]="dropdownSelectOnly"
				></app-cbta-autocomplete>
			}

			<!-- Licence Type -->
			<app-cbta-autocomplete
				[label]="'Licence Type'"
				[placeholder]="'Please Select'"
				[data]="licenseType.value"
				(focusOut)="saveLicenseType($event)"
				[options]="sharedService.getLicenseTypeOptions(formType)"
				[field]="licenseType"
				[readonly]="lockCandidateIdentityFields"
				[clearable]="useTs1V3FlightDetails"
				[selectOnly]="dropdownSelectOnly"
			></app-cbta-autocomplete>

			<!-- Licence Expiry Date -->
			<app-cbta-datepicker
				[datePickerInput]="datePickerInput"
				[inputDesign]="'formType'"
				label="Licence Expiry Date"
				placeHolder="DD/MM/YY"
				[defaultValue]="licenseExpiryDate.value"
				[format]="DATE_FORMAT.LICENSE_DATE_FORMAT"
				(selectedDateChange)="handleDateChange($event)"
				(onDatePickerInit)="onDatePickerInit($event)"
				[isDisabled]="licenseExpiryDate.disabled || lockCandidateIdentityFields"
			></app-cbta-datepicker>

			<!-- Licence Number -->
			<div class="form-element">
				<mat-label for="form-name">Licence Number</mat-label>
				<mat-form-field appearance="outline" class="form-field-responsive mt-1 w-full">
					<input type="text" formControlName="licenseNo" matInput [readonly]="lockCandidateIdentityFields" />
					@if (licenseNo.errors) {
						<mat-error>{{ sharedService.getErrorMessage(licenseNo) }}</mat-error>
					}
				</mat-form-field>
			</div>
		</div>
	}

	@if (shouldRenderSessionSection) {
		<!-- Session Configuration -->
		@if (isTS3 || isTS5) {
			<div class="flex h-16 items-center bg-blue-20 px-4 font-bold leading-6 text-violet md:px-6 lg:bg-violet-light">
				Session Details
			</div>
		}
		<div formGroupName="sessionDetails" class="px-0 py-6 lg:px-6" id="session-checkboxes">
			<p class="mb-4">Please select relevant session. Instructor can select more than <strong>ONE(1)</strong>.</p>

			@if (sessionLayoutMode === "ets1-aoc" && ets1SessionColumns.length && ets1SessionsGroup && ets1SessionRemarksGroup) {
				<div [formGroupName]="ets1SessionGroupCode">
					<app-ets1-aoc-session-config
						[sessions]="ets1SessionsGroup"
						[sessionRemarks]="ets1SessionRemarksGroup"
						[columns]="ets1SessionColumns"
					></app-ets1-aoc-session-config>
				</div>
			} @else if (sessionLayoutMode === "ets35-aoc" && ets35AocSections.length) {
				<app-ets1-aoc-session-config
					[sessions]="sessionsDetails"
					[sessionRemarks]="sessionRemarks"
					[columns]="[]"
					[sections]="ets35AocSections"
				></app-ets1-aoc-session-config>
			} @else {
			<ng-template #sessionRemarkBlock let-groupCode="groupCode" let-session="session">
				@if (isSessionSelected(groupCode, session.code)) {
					@if (useSessionRemarkModal) {
						<div class="pl-6 text-sm">
							@if (getSessionRemarkPreview(groupCode, session.code)) {
								<span class="text-grey-90">{{ getSessionRemarkPreview(groupCode, session.code) }}</span>
							} @else {
								<span class="italic text-grey-60">No details added</span>
							}
							<button
								type="button"
								class="ml-2 cursor-pointer border-0 bg-transparent p-0 text-sm text-red underline"
								(click)="openSessionRemarkEditor(groupCode, session)"
							>
								Edit
							</button>
						</div>
					} @else {
						<div class="form-element pl-6">
							<mat-form-field appearance="outline" class="form-field-responsive w-full">
								<input
									type="text"
									[formControl]="getSessionRemarkControl(groupCode, session.code)"
									matInput
									placeholder="Enter remarks"
								/>
							</mat-form-field>
						</div>
					}
				}
			</ng-template>

			<!-- 1 group -->
			@if (sessionGroups.length === 1) {
				<div
					[formGroupName]="sessionGroups[0].code"
					class="grid grid-cols-1 gap-x-16 gap-y-3 sm:grid-cols-4 lg:grid-cols-4"
				>
					@for (col of singleCols; track $index) {
						<div class="flex flex-col gap-3">
							@for (s of col; track s.code) {
								<div class="flex flex-col gap-1">
									<mat-checkbox [formControlName]="s.code" color="primary">{{ s.description }}</mat-checkbox>
									<ng-container
										*ngTemplateOutlet="sessionRemarkBlock; context: { groupCode: sessionGroups[0].code, session: s }"
									/>
								</div>
							}
						</div>
					}
				</div>
			}

			<!-- 2 groups compact -->
			@if (sessionGroups.length === 3 && !twoGroupsCompact) {
				<div class="grid grid-cols-1 gap-x-12 gap-y-6 sm:grid-cols-4 lg:grid-cols-6">
					<div [formGroupName]="twoColsLeft!.code">
						<div class="mb-2 font-semibold">{{ twoColsLeft!.key }}</div>
						<div class="flex flex-col gap-3">
							@for (s of twoColsLeft!.items; track s.code) {
								<div class="flex flex-col gap-1">
									<mat-checkbox [formControlName]="s.code" color="primary">{{ s.description }}</mat-checkbox>
									<ng-container
										*ngTemplateOutlet="sessionRemarkBlock; context: { groupCode: twoColsLeft!.code, session: s }"
									/>
								</div>
							}
						</div>
					</div>
					@for (col of twoColsRight; track $index) {
						<div [formGroupName]="sessionGroups[1].code">
							@if ($index === 0) {
								<div class="mb-2 font-semibold">{{ secondGroupTitle }}</div>
							} @else {
								<div class="mb-2">&nbsp;</div>
							}
							<div class="flex flex-col gap-3">
								@for (s of col; track s.code) {
									<div class="flex flex-col gap-1">
										<mat-checkbox [formControlName]="s.code" color="primary">{{ s.description }}</mat-checkbox>
										<ng-container
											*ngTemplateOutlet="sessionRemarkBlock; context: { groupCode: sessionGroups[1].code, session: s }"
										/>
									</div>
								}
							</div>
						</div>
					}

					<div [formGroupName]="sessionGroups[2].code">
						<div class="mb-2 font-semibold">Other</div>

						<div class="flex flex-col gap-3">
							<div class="flex flex-col gap-1">
								<mat-checkbox formControlName="not_required" color="primary">{{ "Not required" }}</mat-checkbox>
								<ng-container
									*ngTemplateOutlet="
										sessionRemarkBlock;
										context: { groupCode: sessionGroups[2].code, session: { code: 'not_required', description: 'Not required' } }
									"
								/>
							</div>
						</div>
					</div>
				</div>
			}

			<!-- 2 groups non-compact -->
			@if (sessionGroups.length === 4 && !twoGroupsCompact) {
				<div class="grid grid-cols-1 gap-x-12 gap-y-6 sm:grid-cols-4 lg:grid-cols-6">
					<div [formGroupName]="twoColsLeft!.code">
						<div class="mb-2 font-semibold">{{ twoColsLeft!.key }}</div>
						<div class="flex flex-col gap-3">
							@for (s of twoColsLeft!.items; track s.code) {
								<div class="flex flex-col gap-1">
									<mat-checkbox [formControlName]="s.code" color="primary">{{ s.description }}</mat-checkbox>
									<ng-container
										*ngTemplateOutlet="sessionRemarkBlock; context: { groupCode: twoColsLeft!.code, session: s }"
									/>
								</div>
							}
						</div>
					</div>
					@for (col of twoColsRight; track $index) {
						@if (col.length > 0) {
							<div [formGroupName]="sessionGroups[1].code">
								@if ($index === 0) {
									<div class="mb-2 font-semibold">{{ secondGroupTitle }}</div>
								} @else {
									<div class="mb-2">&nbsp;</div>
								}
								<div class="flex flex-col gap-3">
									@for (s of col; track s.code) {
										<div class="flex flex-col gap-1">
											<mat-checkbox [formControlName]="s.code" color="primary">{{ s.description }}</mat-checkbox>
											<ng-container
												*ngTemplateOutlet="sessionRemarkBlock; context: { groupCode: sessionGroups[1].code, session: s }"
											/>
										</div>
									}
								</div>
							</div>
						}
					}
					@for (col of lastCols; track $index) {
						<div [formGroupName]="sessionGroups[2].code">
							@if ($index === 0) {
								<div class="mb-2 font-semibold">{{ lastColTitle }}</div>
							} @else {
								<div class="mb-2">&nbsp;</div>
							}
							<div class="flex flex-col gap-3">
								@for (s of col; track s.code) {
									<div class="flex flex-col gap-1">
										<mat-checkbox [formControlName]="s.code" color="primary">{{ s.description }}</mat-checkbox>
										<ng-container
											*ngTemplateOutlet="sessionRemarkBlock; context: { groupCode: sessionGroups[2].code, session: s }"
										/>
									</div>
								}
							</div>
						</div>
					}

					<div [formGroupName]="sessionGroups[3].code">
						<div class="mb-2 font-semibold">Other</div>

						<div class="flex flex-col gap-3">
							<div class="flex flex-col gap-1">
								<mat-checkbox formControlName="not_required" color="primary">{{ "Not required" }}</mat-checkbox>
								<ng-container
									*ngTemplateOutlet="
										sessionRemarkBlock;
										context: { groupCode: sessionGroups[3].code, session: { code: 'not_required', description: 'Not required' } }
									"
								/>
							</div>
						</div>
					</div>
				</div>
			}

			<!-- 3+ groups -->
			@if (sessionGroups.length >= 5) {
				<div class="grid grid-cols-1 gap-x-12 gap-y-6 sm:grid-cols-3 lg:grid-cols-3">
					@for (g of sessionGroups; track g.code) {
						<div [formGroupName]="g.code">
							<div class="mb-2 font-semibold">{{ g.key }}</div>
							<div class="flex flex-col gap-3">
								@for (s of g.items; track s.code) {
									<div class="flex flex-col gap-1">
										<mat-checkbox [formControlName]="s.code" color="primary">{{ s.description }}</mat-checkbox>
										<ng-container
											*ngTemplateOutlet="sessionRemarkBlock; context: { groupCode: g.code, session: s }"
										/>
									</div>
								}
							</div>
						</div>
					}
				</div>
			}

			@if (sessionGroups.length === 0) {
				<p class="italic text-gray-500">No sessions available.</p>
			}
			}
		</div>
	}

	<!-- Shared flight / simulator block (below all candidates) or legacy per-panel fields -->
	@if (shouldRenderFlightSimulatorSection) {
		<div [formGroup]="flightSimulatorDetails" [class.flight-sim-section--disabled]="flightSimDisabled">
			<div
				class="flight-sim-section-header flex items-center"
				[ngClass]="
					isTS3 || isTS5
						? 'h-16 bg-blue-20 px-4 font-bold leading-6 text-violet md:px-6 lg:bg-violet-light'
						: 'h-[40px] bg-blue-20 px-4 py-2 text-black'
				"
			>
				<span [class.text-lg]="!(isTS3 || isTS5)" [class.font-medium]="!(isTS3 || isTS5)">
					@if (flightSimMode === "classroom") {
						Classroom Details
					} @else if (useTs1V3FlightDetails) {
						Flight Details
					} @else if (flightSimMode === "simulator") {
						Simulator Details
					} @else if (flightSimMode === "aircraft") {
						Aircraft Details
					} @else {
						Flight / Simulator Details
					}
				</span>
			</div>

			<!-- add data-hide-clear flag to hide "×" visually when disabled -->
			<div
				class="grid grid-cols-2 gap-4 p-4"
				[class.flight-sim-fields--disabled]="flightSimDisabled"
				[attr.data-hide-clear]="flightSimDisabled"
			>
				@if (showAircraftSimulatorToggle && flightModeRadios) {
					<mat-radio-group class="col-span-2 flex flex-wrap gap-6" formControlName="aircraftOrSimulator">
						<mat-radio-button value="aircraft" color="primary">Aircraft</mat-radio-button>
						<mat-radio-button value="simulator" color="primary">Simulator</mat-radio-button>
						<mat-radio-button value="classroom" color="primary">Classroom</mat-radio-button>
					</mat-radio-group>
				} @else if (showAircraftSimulatorToggle) {
					<div class="flight-sim-mode-row col-span-2">
						<span class="flight-sim-mode-row__label">Aircraft</span>
						<button
							type="button"
							class="flight-sim-switch"
							[class.flight-sim-switch--simulator]="flightSimMode === 'simulator'"
							[disabled]="flightSimDisabled"
							role="switch"
							[attr.aria-checked]="flightSimMode === 'simulator'"
							aria-label="Toggle between aircraft and simulator"
							(click)="toggleFlightSimMode()"
						>
							<span class="flight-sim-switch__track" aria-hidden="true"></span>
							<span class="flight-sim-switch__thumb" aria-hidden="true"></span>
						</button>
						<span class="flight-sim-mode-row__label">Simulator</span>
					</div>
				}
				@if (flightModeRadios && flightSimMode === "classroom") {
					<div class="form-element col-span-2 sm:col-span-1">
						<mat-label for="ets35-classroom">Classroom</mat-label>
						<mat-form-field appearance="outline" class="form-field-responsive mt-1 w-full">
							<input
								id="ets35-classroom"
								type="text"
								formControlName="classroomFreeText"
								matInput
								[matAutocomplete]="classroomAuto"
								maxlength="100"
								placeholder="Select or type classroom"
							/>
							<mat-autocomplete #classroomAuto="matAutocomplete">
								@for (room of classroomOptions; track room) {
									<mat-option [value]="room">{{ room }}</mat-option>
								}
							</mat-autocomplete>
							@if (classroomFreeTextControl?.hasError("required") && classroomFreeTextControl?.touched) {
								<mat-error>Please enter or select a classroom.</mat-error>
							}
						</mat-form-field>
					</div>
				}
				@if (flightSimMode !== "classroom") {
				@if (showAircraftSimulatorToggle) {
					@if (flightSimMode === "aircraft") {
						<div class="form-element col-span-2 sm:col-span-1">
							<mat-label for="aircraft-reg-suffix">Aircraft Registration</mat-label>
							<mat-form-field appearance="outline" class="form-field-responsive mt-1 w-full">
								@if (aircraftRegPrefix) {
									<span matTextPrefix class="me-1 whitespace-nowrap font-medium">{{ aircraftRegPrefix }}</span>
								}
								<input
									id="aircraft-reg-suffix"
									type="text"
									matInput
									[formControl]="aircraftSuffixOnly"
									[errorStateMatcher]="aircraftRegistrationErrorStateMatcher"
									[readonly]="aircraftSuffixOnly.disabled"
									[attr.maxlength]="5"
									autocomplete="off"
									inputmode="text"
									[spellcheck]="false"
									(blur)="markAircraftRegistrationTouched()"
								/>
								@if (
									aircraftRegistration.hasError("required") &&
									(aircraftRegistration.touched || aircraftSuffixOnly.touched)
								) {
									<mat-error>{{ sharedService.getErrorMessage(aircraftRegistration) }}</mat-error>
								}
								@if (
									aircraftRegistration.hasError("aircraftRegTail") &&
									(aircraftRegistration.touched || aircraftSuffixOnly.touched)
								) {
									<mat-error>Enter 3 to 5 alphanumeric characters.</mat-error>
								}
								@if (
									aircraftRegistration.hasError("aircraftRegPrefix") &&
									(aircraftRegistration.touched || aircraftSuffixOnly.touched)
								) {
									<mat-error>Registration must start with {{ aircraftRegPrefix }}.</mat-error>
								}
							</mat-form-field>
						</div>

						<div class="form-element col-span-2 sm:col-span-1">
							<app-cbta-autocomplete
								[label]="'Aircraft Type'"
								[placeholder]="'Please Select'"
								[data]="acType.value"
								(focusOut)="saveACType($event)"
								[options]="sharedService.dropDownOptionsAircraftType"
								[field]="acType"
								[isDisabled]="acType.disabled"
								[clearable]="useTs1V3FlightDetails"
								[selectOnly]="dropdownSelectOnly"
							></app-cbta-autocomplete>
						</div>
					}

					@if (flightSimMode === "simulator") {
						<div class="form-element col-span-2 sm:col-span-1">
							<app-cbta-autocomplete
								[label]="'Simulator Registration'"
								[placeholder]="'Select or type manually'"
								[data]="simulatorRegistration.value"
								(focusOut)="saveSimulatorRegistration($event)"
								[options]="simulatorRegistrationOptions"
								[field]="simulatorRegistration"
								[isDisabled]="simulatorRegistration.disabled"
								[useFuzzySearch]="true"
								[clearable]="useTs1V3FlightDetails"
							></app-cbta-autocomplete>
						</div>

						<div class="form-element col-span-2 sm:col-span-1">
							<app-cbta-autocomplete
								[label]="'Aircraft Type'"
								[placeholder]="'Please Select'"
								[data]="acType.value"
								(focusOut)="saveACType($event)"
								[options]="sharedService.dropDownOptionsAircraftType"
								[field]="acType"
								[isDisabled]="acType.disabled"
								[clearable]="useTs1V3FlightDetails"
								[selectOnly]="dropdownSelectOnly"
							></app-cbta-autocomplete>
						</div>
					}
				} @else {
					<div class="form-element">
						<mat-label for="form-name">ACFT / Sim Registration</mat-label>
						<mat-form-field appearance="outline" class="form-field-responsive mt-1 w-full">
							<input type="text" formControlName="aircraftSimReg" matInput />
						</mat-form-field>
					</div>

					<div class="form-element">
						<app-cbta-autocomplete
							[label]="'A/C Type'"
							[placeholder]="'Please Select'"
							[data]="acType.value"
							(focusOut)="saveACType($event)"
							[options]="sharedService.dropDownOptionsAircraftType"
							[field]="acType"
							[isDisabled]="acType.disabled"
							[clearable]="useTs1V3FlightDetails"
							[selectOnly]="dropdownSelectOnly"
						></app-cbta-autocomplete>
					</div>
				}

				@if (useTs1V3FlightDetails) {
					<div class="form-element">
						<app-cbta-autocomplete
							[label]="'Accumulated Sectors'"
							[placeholder]="'Please Select'"
							[data]="accumulatedSectors.value"
							(focusOut)="saveAccSec($event)"
							[options]="sharedService.dropDownOptionsSecNum"
							[field]="accumulatedSectors"
							[isDisabled]="accumulatedSectors.disabled"
							[clearable]="useTs1V3FlightDetails"
							[selectOnly]="dropdownSelectOnly"
						></app-cbta-autocomplete>
					</div>

					<div class="form-element">
						<app-cbta-autocomplete
							[label]="'Sector No.'"
							[placeholder]="'Please Select'"
							[data]="sectorNo.value"
							(focusOut)="saveSecNum($event)"
							[options]="sharedService.dropDownOptionsSecNum"
							[field]="sectorNo"
							[isDisabled]="sectorNo.disabled"
							[clearable]="useTs1V3FlightDetails"
							[selectOnly]="dropdownSelectOnly"
						></app-cbta-autocomplete>
					</div>

					@if (flightSimMode === "aircraft" || flightSimMode === "simulator") {
						<div class="form-element col-span-2 flight-sectors-block" formArrayName="sectors">
							<mat-label class="flight-sectors-block__title">Select Departure &amp; Destination (ICAO)</mat-label>
							<div class="flight-sectors-table" role="table">
								<div class="flight-sectors-table__head" role="row">
									<mat-label class="flight-sectors-table__col flight-sectors-table__col--no" role="columnheader"
										>No.</mat-label
									>
									<mat-label class="flight-sectors-table__col flight-sectors-table__col--icao" role="columnheader"
										>Departure (ICAO)</mat-label
									>
									<mat-label class="flight-sectors-table__col flight-sectors-table__col--icao" role="columnheader"
										>Destination (ICAO)</mat-label
									>
									<mat-label class="flight-sectors-table__col flight-sectors-table__col--action" role="columnheader"
										>Action</mat-label
									>
								</div>
								@for (sector of sectors.controls; track $index; let i = $index) {
									<div class="flight-sectors-table__row" role="row" [formGroupName]="i">
										<span class="flight-sectors-table__col flight-sectors-table__col--no" role="cell">{{
											i + 1
										}}</span>
										<div class="flight-sectors-table__col flight-sectors-table__col--icao" role="cell">
											<mat-form-field
												appearance="outline"
												class="form-field-responsive flight-sectors-field w-full"
												subscriptSizing="dynamic"
											>
												<input
													type="text"
													formControlName="departureIcao"
													matInput
													maxlength="4"
													style="text-transform: uppercase"
													[attr.aria-label]="'Departure ICAO sector ' + (i + 1)"
													(blur)="onSectorDestinationOrDepartureChange(i)"
												/>
												@if (sectorDepartureControl(i)?.invalid && sectorDepartureControl(i)?.touched) {
													<mat-error>{{ sharedService.getErrorMessage(sectorDepartureControl(i)!) }}</mat-error>
												}
											</mat-form-field>
										</div>
										<div class="flight-sectors-table__col flight-sectors-table__col--icao" role="cell">
											<mat-form-field
												appearance="outline"
												class="form-field-responsive flight-sectors-field w-full"
												subscriptSizing="dynamic"
											>
												<input
													type="text"
													formControlName="destinationIcao"
													matInput
													maxlength="4"
													style="text-transform: uppercase"
													[attr.aria-label]="'Destination ICAO sector ' + (i + 1)"
													(input)="onSectorDestinationChange(i)"
													(blur)="onSectorDestinationOrDepartureChange(i)"
												/>
												@if (sectorDestinationControl(i)?.invalid && sectorDestinationControl(i)?.touched) {
													<mat-error>{{
														sharedService.getErrorMessage(sectorDestinationControl(i)!)
													}}</mat-error>
												}
											</mat-form-field>
										</div>
										<div class="flight-sectors-table__col flight-sectors-table__col--action" role="cell">
											<button
												type="button"
												class="flight-sectors-remove"
												[disabled]="flightSimDisabled || sectors.length <= 1"
												[attr.aria-label]="'Remove sector ' + (i + 1)"
												(click)="removeFlightSector(i)"
											>
												<span class="flight-sectors-remove__bar" aria-hidden="true"></span>
											</button>
										</div>
									</div>
								}
							</div>
							<button
								type="button"
								class="flight-sectors-add"
								[disabled]="flightSimDisabled || !canAddFlightSector"
								(click)="addFlightSector()"
							>
								<img
									class="flight-sectors-add__icon"
									src="assets/icons/flight-sector-add.svg"
									width="28"
									height="28"
									alt=""
									aria-hidden="true"
								/>
								<span>Add Another Sector (max {{ maxFlightSectors }})</span>
							</button>
						</div>
					}

					@if (flightSimMode === "simulator") {
						<div class="form-element col-span-2 sm:col-span-1">
							<mat-label for="other-airports-route">Other Airport(s)/Route(s)</mat-label>
							<mat-form-field appearance="outline" class="form-field-responsive mt-1 w-full">
								<input id="other-airports-route" type="text" formControlName="otherAirportsRoute" matInput />
							</mat-form-field>
						</div>
					}
				} @else {
					<div class="form-element">
						<mat-label for="form-name">Airport / Route</mat-label>
						<mat-form-field appearance="outline" class="form-field-responsive mt-1 w-full">
							<input type="text" formControlName="airportRoute" matInput />
						</mat-form-field>
					</div>

					<div class="form-element">
						<app-cbta-autocomplete
							[label]="'Sector Number'"
							[placeholder]="'Please Select'"
							[data]="sectorNo.value"
							(focusOut)="saveSecNum($event)"
							[options]="sharedService.dropDownOptionsSecNum"
							[field]="sectorNo"
							[isDisabled]="sectorNo.disabled"
							[clearable]="useTs1V3FlightDetails"
							[selectOnly]="dropdownSelectOnly"
						></app-cbta-autocomplete>
					</div>

					<div class="form-element">
						<app-cbta-autocomplete
							[label]="'Accumulated Sectors'"
							[placeholder]="'Please Select'"
							[data]="accumulatedSectors.value"
							(focusOut)="saveAccSec($event)"
							[options]="sharedService.dropDownOptionsSecNum"
							[field]="accumulatedSectors"
							[isDisabled]="accumulatedSectors.disabled"
							[clearable]="useTs1V3FlightDetails"
							[selectOnly]="dropdownSelectOnly"
						></app-cbta-autocomplete>
					</div>
				}
				}
			</div>
		</div>
	}
</div>
